// lib/isPlasmicProxy.ts

export function isPlasmicProxy(urlStr?: string): boolean {
  // 1. Only run in development
  if (process.env.NODE_ENV !== 'development') return false;

  const isServer = typeof window === 'undefined';
  
  // Use provided URL, or window location, or skip if neither exists
  const currentUrl = urlStr ? new URL(urlStr) : !isServer ? new URL(window.location.href) : null;
  if (!currentUrl) return false;

  // 2. Check for Plasmic origin parameter (Initial page load or explicit API calls)
  const originParam = 
    currentUrl.searchParams.get('origin') || 
    (currentUrl.hash && new URLSearchParams(currentUrl.hash.substring(1)).get('origin'));

  if (originParam && (originParam.includes('plasmic.app') || originParam.includes('localhost'))) {
    return true;
  }

  // 3. Bypass Auth for the Proxy API route itself in dev mode
  if (currentUrl.pathname === '/api/plasmic-studio-proxy') {
    return true;
  }

  // 4. Iframe check (Client-side only)
  if (!isServer) {
    const inIframe = window.self !== window.top;
    const isLocal = 
      window.location.hostname === 'localhost' || 
      window.location.hostname === '127.0.0.1' || 
      window.location.hostname.includes('dev.regrade.net');

    if (inIframe && isLocal) return true;
  }

  return false;
}